<div fxLayout="column" ngStyle.xs="margin:0% 15vw;  padding-top: 15vh" ngStyle.sm="margin: 0% 20vw;  padding-top: 18vh"
  ngStyle.md="margin: 0% 25vw; padding-top: 15vh" ngStyle.lg="margin: 0% 35vw;  padding-top: 13vh"
  ngStyle.xl="margin: 0% 35vw;  padding-top: 15vh">
  <!-- MAIN USER SECTION START -->
  <mat-card style="border-radius: 10px;" >
    <span fxFlexAlign="center" ngClass="span-username medium" ngClass.xs="span-username xs medium">
      Page Not Found
    </span>
  </mat-card>
</div>
